export * from './offer-letter-gen.component';
export * from './offer-letter-gen-view.component';